
import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Services = () => {
  const serviceItems = [
    {
      title: 'Exterior Rendering',
      description: 'Photorealistic visualisations of architectural exteriors, capturing mood, lighting, and environmental context.',
      icon: FiIcons.FiHome
    },
    {
      title: 'Interior Visualization',
      description: 'Highly detailed interior renders showcasing materials, lighting, and spatial atmosphere for real estate and design.',
      icon: FiIcons.FiLayout
    },
    {
      title: '3D Floor Plans',
      description: 'Clear, engaging 3D top-down views that help clients understand spatial flow and layout dimensions.',
      icon: FiIcons.FiMap
    },
    {
      title: 'Architectural Animation',
      description: 'Cinematic walkthroughs and flyovers that bring unbuilt spaces to life with fluid motion and realistic lighting.',
      icon: FiIcons.FiVideo
    }
  ];

  return (
    <section id="services" className="py-24 md:py-32 bg-neutral-900 text-white border-t border-neutral-800">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div 
          className="text-center max-w-3xl mx-auto mb-20"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-neutral-400 uppercase tracking-widest text-sm mb-4 block">Our Expertise</span>
          <h2 className="text-4xl md:text-5xl font-light">Precision in <span className="font-serif italic font-semibold">Every Detail</span></h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-16">
          {serviceItems.map((service, index) => (
            <motion.div 
              key={service.title}
              className="group flex flex-col md:flex-row gap-6 items-start"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <div className="p-4 bg-neutral-950 rounded-lg text-neutral-400 group-hover:text-white transition-colors duration-300 shrink-0">
                <SafeIcon icon={service.icon} className="w-6 h-6" />
              </div>
              <div>
                <h3 className="text-xl font-medium mb-3 text-white group-hover:text-neutral-200 transition-colors">{service.title}</h3>
                <p className="text-neutral-400 leading-relaxed font-light">
                  {service.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
